<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, viewport-fit=cover, interactive-widget=resizes-content"
    />
    <title>OpenClaw Control</title>
    <meta name="color-scheme" content="dark light" />
    <!-- These mirror the claw theme's --bg tokens for first paint; runtime theme application keeps them synchronized. -->
    <meta
      id="openclaw-theme-color-light"
      name="theme-color"
      media="(prefers-color-scheme: light)"
      content="#f4f4f4"
    />
    <meta
      id="openclaw-theme-color-dark"
      name="theme-color"
      media="(prefers-color-scheme: dark)"
      content="#111318"
    />
    <link id="openclaw-favicon-svg" rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link
      id="openclaw-favicon-png"
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="/favicon-32.png"
    />
    <link
      id="openclaw-apple-touch-icon"
      rel="apple-touch-icon"
      sizes="180x180"
      href="/apple-touch-icon.png"
    />
    <link
      id="openclaw-manifest"
      rel="manifest"
      href="/manifest.webmanifest"
      crossorigin="use-credentials"
    />
    <script data-cfasync="false">
      // Configure Zod before module evaluation so its JIT probe cannot violate strict CSP.
      globalThis.__zod_globalConfig ??= {};
      globalThis.__zod_globalConfig.jitless = true;

      (function () {
        // The critical frame can paint while the entry stylesheet downloads.
        // Activate it before the app mounts, including when module loading stalls.
        function activateBootStyles(event) {
          var link = event.target;
          if (link.id !== "openclaw-boot-styles") return;
          link.media = "all";
          document.removeEventListener("load", activateBootStyles, true);
          document.removeEventListener("error", activateBootStyles, true);
        }
        document.addEventListener("load", activateBootStyles, true);
        document.addEventListener("error", activateBootStyles, true);
        var bootBase =
          document.documentElement.getAttribute("data-openclaw-control-ui-base-path") || "";
        var bootPath = location.pathname.slice(bootBase.length) || "/";
        // Keep this data-free route selection in sync with ConnectingSplash.
        var bootRoute = /^\/new\/?$/.test(bootPath)
          ? "new"
          : /^\/(?:settings\/)?sessions\/?$/.test(bootPath)
            ? "sessions"
            : /^\/(?:automations|cron)\/?$/.test(bootPath)
              ? "cron"
              : /^\/settings(?:\/|$)/.test(bootPath)
                ? "settings"
                : /^\/chat(?:\/|$)/.test(bootPath) &&
                    !new URLSearchParams(location.search).has("catalog")
                  ? "chat"
                  : "other";
        document.documentElement.setAttribute("data-openclaw-boot-route", bootRoute);
        document.documentElement.toggleAttribute("data-openclaw-boot-chat", bootRoute === "chat");
        var THEMES = {
          claw: 1,
          knot: 1,
          dash: 1,
          absolutely: 1,
          tide: 1,
          beacon: 1,
          phosphor: 1,
          crt: 1,
          manuscript: 1,
          rose: 1,
          miami: 1,
        };
        var MODES = { system: 1, light: 1, dark: 1 };
        var LEGACY = {
          dark: "claw:dark",
          light: "claw:light",
          openknot: "knot:dark",
          fieldmanual: "dash:dark",
          clawdash: "dash:light",
          system: "claw:system",
        };
        try {
          var keys = Object.keys(localStorage);
          var raw;
          for (var i = 0; i < keys.length; i++) {
            if (keys[i].indexOf("openclaw.control.settings.v1") === 0) {
              raw = localStorage.getItem(keys[i]);
              if (raw) break;
            }
          }
          var s = raw ? JSON.parse(raw) : null;
          if (s && typeof s.navWidth === "number" && s.navWidth >= 240 && s.navWidth <= 400) {
            document.documentElement.style.setProperty(
              "--openclaw-boot-nav-width",
              s.navWidth + "px",
            );
          }
          // The boot composer follows the saved send shortcut before the app loads.
          if (s && s.chatSendShortcut === "modifier-enter") {
            document.documentElement.setAttribute("data-openclaw-boot-send-shortcut", "modifier");
          }
          var t = s && s.theme;
          var m = s && s.themeMode;
          if (typeof t !== "string") t = "";
          if (typeof m !== "string") m = "";
          var legacy = LEGACY[t];
          var theme = THEMES[t] ? t : legacy ? legacy.split(":")[0] : "claw";
          var mode = MODES[m] ? m : legacy ? legacy.split(":")[1] : "system";
          if (mode === "system") {
            mode = window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
          }
          // family -> [dark, light] resolved names. Kept in lockstep with
          // resolveTheme() in app/theme.ts and the files in public/themes.
          var FAMILIES = {
            knot: ["openknot", "openknot-light"],
            dash: ["dash", "dash-light"],
            absolutely: ["absolutely", "absolutely-light"],
            tide: ["tide", "tide-light"],
            beacon: ["beacon", "beacon-light"],
            phosphor: ["phosphor", "phosphor-light"],
            crt: ["crt", "crt-light"],
            manuscript: ["manuscript", "manuscript-light"],
            rose: ["rose", "rose-light"],
            miami: ["miami", "miami-light"],
          };
          var pair = FAMILIES[theme];
          var resolved = pair
            ? pair[mode === "light" ? 1 : 0]
            : mode === "light"
              ? "light"
              : "dark";
          if (pair) {
            // Script-created links need explicit render blocking before first paint.
            // The gateway stamps the mount prefix and asset version before this runs.
            var base =
              document.documentElement.getAttribute("data-openclaw-control-ui-base-path") || "";
            var buildId = document.documentElement.getAttribute(
              "data-openclaw-control-ui-build-id",
            );
            var version = buildId ? "?v=" + encodeURIComponent(buildId) : "";
            var palette = document.createElement("link");
            palette.rel = "stylesheet";
            palette.setAttribute("blocking", "render");
            palette.id = "openclaw-theme-palette-" + theme;
            palette.onerror = function () {
              palette.remove();
            };
            palette.href = base + "/themes/" + theme + ".css" + version;
            document.head.appendChild(palette);
          }
          document.documentElement.setAttribute("data-theme", resolved);
          var resolvedMode = resolved.includes("light") ? "light" : "dark";
          document.documentElement.setAttribute("data-theme-mode", resolvedMode);
          // Plugin semantic styles select on [data-theme-resolved]; keep in lockstep.
          document.documentElement.setAttribute("data-theme-resolved", resolvedMode);
        } catch (e) {}
      })();
    </script>
    <style>
      /* Paint before the app stylesheet arrives so WebKit never exposes a white
         document between its native dark canvas and the persisted UI theme. */
      html,
      body {
        min-height: 100%;
      }

      html {
        background: #111318;
        color-scheme: dark;
      }

      html[data-theme-mode="light"] {
        background: #f4f4f4;
        color-scheme: light;
      }

      html[data-theme="openknot"] {
        background: #0c0c0c;
      }

      html[data-theme="openknot-light"] {
        background: #f0f0f3;
      }

      html[data-theme="dash"] {
        background: #1e1613;
      }

      html[data-theme="dash-light"] {
        background: #e8e2dc;
      }

      html[data-theme="absolutely"] {
        background: #1f1f1e;
      }

      html[data-theme="absolutely-light"] {
        background: #f3f2f1;
      }

      html[data-theme="tide"] {
        background: #14191f;
      }

      html[data-theme="tide-light"] {
        background: #edeff1;
      }

      html[data-theme="beacon"] {
        background: #050505;
      }

      html[data-theme="beacon-light"] {
        background: #f3f3f3;
      }

      html[data-theme="phosphor"] {
        background: #0e130e;
      }

      html[data-theme="phosphor-light"] {
        background: #edf0ed;
      }

      html[data-theme="crt"] {
        background: #0d0e0d;
      }

      html[data-theme="crt-light"] {
        background: #f0f0f0;
      }

      html[data-theme="manuscript"] {
        background: #25221b;
      }

      html[data-theme="manuscript-light"] {
        background: #edece6;
      }

      html[data-theme="rose"] {
        background: #1d1b28;
      }

      html[data-theme="rose-light"] {
        background: #edeae7;
      }

      html[data-theme="miami"] {
        background: #181322;
      }

      html[data-theme="miami-light"] {
        background: #f2eef1;
      }

      body {
        margin: 0;
        min-height: 100%;
        background: inherit;
        color-scheme: inherit;
      }

      /* Critical loading layout lives here so HTML and the Solid fallback share
         one geometry owner before either the entry stylesheet or JS arrives. */
      openclaw-app {
        display: block;
        box-sizing: border-box;
        height: var(--shell-canvas-height, 100dvh);
        padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px)
          env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
      }

      /* Connection and route loading share the document's static placeholder paint. */
      .connect-splash--skeleton,
      .content--workbench .lazy-view-state--route {
        --boot-ink: var(--text, #bcbcc0);
        --boot-line: color-mix(in srgb, var(--boot-ink) 10%, transparent);
        --boot-content-bg: #0e1015;
      }

      .content--workbench .lazy-view-state--route {
        position: relative;
        background: var(--bg-content, var(--boot-content-bg));
        container-type: inline-size;
        min-height: 0;
      }

      .connect-splash.connect-splash--skeleton {
        position: relative;
        display: flex;
        align-items: stretch;
        box-sizing: border-box;
        height: 100vh;
        height: var(
          --shell-content-height,
          calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))
        );
        overflow: hidden;
        background: var(--bg, inherit);
        opacity: 1;
        animation: none;
      }

      html[data-theme-mode="light"]
        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route) {
        --boot-ink: var(--text, #353535);
        --boot-content-bg: #f8f8f8;
      }

      .connect-splash__layout {
        display: grid;
        grid-template-columns: calc(var(--openclaw-boot-nav-width, 258px) + 52px) minmax(0, 1fr);
        width: 100%;
        height: 100%;
        min-height: 0;
      }

      .connect-splash__main {
        position: relative;
        container-type: inline-size;
        min-width: 0;
        min-height: 0;
        height: 100%;
        background: var(--bg-content, var(--boot-content-bg));
      }

      .connect-splash__sidebar {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 24px;
        box-sizing: border-box;
        padding: 16px 20px 16px 72px;
        border-inline-end: 1px solid var(--boot-line);
      }

      .connect-splash__sidebar::before {
        position: absolute;
        inset: 0 auto 0 0;
        width: 51px;
        border-inline-end: 1px solid var(--boot-line);
        content: "";
      }

      .connect-splash__new-session {
        height: 32px;
        margin: 8px 0;
      }

      .connect-splash__sidebar > .skeleton-line:nth-child(even) {
        width: 65%;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route) .skeleton {
        position: relative;
        overflow: hidden;
        border-radius: 6px;
        background: color-mix(in srgb, var(--boot-ink) 8%, transparent);
      }

      /* Static placeholders do not animate or hold compositor layers during boot. */
      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route) .skeleton::after {
        content: none;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route) .skeleton-line {
        height: 14px;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .skeleton-line--medium {
        width: 65%;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .skeleton-line--long {
        width: 85%;
      }

      .lazy-view-state--route > .connect-splash__status {
        display: none;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .connect-splash__status {
        display: block;
        position: absolute;
        inset: auto 18px 50px;
        margin: 0;
        color: var(--boot-ink);
        font:
          14px/20px system-ui,
          sans-serif;
        letter-spacing: normal;
        -webkit-font-smoothing: auto;
        text-align: center;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton {
        box-sizing: border-box;
        gap: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        min-width: 0;
        min-height: 0;
        padding: 0 18px 14px;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__header {
        box-sizing: border-box;
        display: flex;
        flex: none;
        align-items: center;
        gap: 14px;
        height: 44px;
        margin-inline: -18px;
        padding-inline: 12px;
        padding-bottom: 0;
        border-bottom: 1px solid var(--boot-line, var(--border));
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__avatar {
        flex: none;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__title {
        width: 140px;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__messages {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 48px;
        width: min(100%, 48rem);
        margin: 28px auto 0;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__message {
        display: grid;
        gap: 14px;
        width: 85%;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__message--user {
        align-self: flex-end;
        width: 48%;
      }

      :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__composer {
        box-sizing: border-box;
        flex: none;
        width: min(100%, 48rem);
        height: 92px;
        margin: 8px auto 0;
        border: 1px solid var(--boot-line, var(--border));
        border-radius: 20px;
      }

      /* Chat frames hold the live boot composer; status text stays above it.
         First-paint tokens only, so every loading frame paints identical pixels.
         Sizes mirror the chat composer's desktop stack and mobile writing row,
         growing to six lines, so the handoff keeps text and frame still. */
      html:not([data-openclaw-boot-chat]) #openclaw-boot-composer {
        display: none;
      }

      /* The chat composer's surface; fallbacks match the default theme's tokens
         until the app stylesheet defines --chat-composer-surface. */
      html[data-openclaw-boot-chat]
        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__composer:has(> #openclaw-boot-composer) {
        height: auto;
        background: var(
          --chat-composer-surface,
          color-mix(in srgb, var(--boot-ink) 14%, var(--bg-content, var(--boot-content-bg)))
        );
      }

      html[data-openclaw-boot-chat][data-theme-mode="light"]
        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
        .loading-skeleton__composer:has(> #openclaw-boot-composer) {
        background: var(
          --chat-composer-surface,
          color-mix(in srgb, var(--bg-content, var(--boot-content-bg)) 50%, white)
        );
      }

      #openclaw-boot-composer {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-height: 86px;
        max-height: 188px;
        field-sizing: content;
        margin: 0;
        padding: 12px 14px 50px;
        border: 0;
        border-radius: inherit;
        background: none;
        color: var(--boot-ink);
        font:
          14px/21px system-ui,
          sans-serif;
        resize: none;
        outline: none;
      }

      #openclaw-boot-composer::placeholder,
      #openclaw-boot-composer[data-submit-queued] {
        color: color-mix(in srgb, var(--boot-ink) 55%, transparent);
        opacity: 1;
      }

      :is(
          html[data-openclaw-boot-chat] #openclaw-boot-shell,
          .connect-splash[data-chat],
          .content--workbench .lazy-view-state--route[data-chat]
        )
        .connect-splash__status {
        bottom: 132px;
      }

      /* A growing draft needs no loading text over it. */
      :is(.connect-splash__main, .lazy-view-state--route):has(
          > .loading-skeleton #openclaw-boot-composer:not(:placeholder-shown)
        )
        > .connect-splash__status {
        visibility: hidden;
      }

      @media (max-width: 900px) {
        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton:has(#openclaw-boot-composer:focus, .loading-skeleton__content) {
          padding-bottom: 6px;
        }
      }

      @media (max-width: 900px),
        (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        /* Merged web chrome uses the mobile composer; native shells retain its base gap. */
        html:not(.openclaw-native-macos, .openclaw-native-nav, .openclaw-native-web-chrome)
          :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton:has(#openclaw-boot-composer) {
          padding-bottom: 10px;
        }
      }

      @media (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        html:not(.openclaw-native-macos, .openclaw-native-nav, .openclaw-native-web-chrome)
          :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton:has(#openclaw-boot-composer) {
          padding-inline: 16px;
        }

        html[data-openclaw-boot-chat]:not(
            .openclaw-native-macos,
            .openclaw-native-nav,
            .openclaw-native-web-chrome
          )
          :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton:has(#openclaw-boot-composer)
          > .loading-skeleton__messages:not(.loading-skeleton__content) {
          min-height: 0;
          overflow: hidden;
        }
      }

      @media (max-width: 768px) {
        /* The idle mobile capsule shows one line beside its attachment button;
           focus opens the editing form like the chat composer. */
        #openclaw-boot-composer {
          min-height: 50px;
          max-height: 50px;
          padding: 13px 16px 0 42px;
          line-height: 24px;
        }

        html[data-openclaw-boot-chat]
          :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton__composer:has(> #openclaw-boot-composer:focus) {
          border-radius: 20px;
        }

        /* Recovery controls must not move between pointer down and click when
           the editor loses focus. Keep its editing space while recovery is shown. */
        #openclaw-boot-composer:focus,
        .loading-skeleton:has(.loading-skeleton__content) #openclaw-boot-composer {
          min-height: 90px;
          max-height: 192px;
          padding: 12px 14px 54px;
          line-height: 21px;
        }
      }

      @media (pointer: coarse) {
        #openclaw-boot-composer {
          /* Touch browsers zoom into editors below 16px. */
          font-size: 16px;
          line-height: 24px;
        }
      }

      @media (pointer: coarse) and (max-width: 768px) {
        #openclaw-boot-composer:focus {
          max-height: 210px;
          line-height: 24px;
        }
      }

      @media (min-width: 769px) {
        html[data-openclaw-boot-chat] #openclaw-boot-shell .loading-skeleton__composer,
        .connect-splash[data-chat] .loading-skeleton__composer,
        .content--workbench .lazy-view-state--route .loading-skeleton__composer {
          /* Match composer-surface: one editor line, five vertical insets,
             the send control, the footer margin, and both surface borders. */
          height: max(
            var(--chat-composer-min-height, 88px),
            calc(
              var(--chat-composer-editor-line, calc(var(--control-ui-text-md, 14px) * 1.5)) +
                var(--chat-composer-editor-inset-block, 6px) * 5 +
                var(--chat-composer-send-size, 32px) + 4px + 2px
            )
          );
        }
      }

      @media (max-width: 900px),
        (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        html[data-openclaw-boot-chat]:not(
            .openclaw-native-macos,
            .openclaw-native-nav,
            .openclaw-native-web-chrome
          )
          :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton__composer:has(> #openclaw-boot-composer) {
          /* Mirror the permanent mobile writing row and its external toolbar band. */
          display: grid;
          grid-template-columns: 32px minmax(0, 1fr) 76px;
          grid-template-rows: max-content minmax(36px, max-content);
          align-content: start;
          align-items: center;
          gap: 0 2px;
          min-height: 52px;
          height: auto;
          margin-block-start: 48px;
          padding: 7px 8px;
          border-radius: calc(28px * var(--openclaw-corner-radius-scale, 1));
        }

        html[data-openclaw-boot-chat]:not(
            .openclaw-native-macos,
            .openclaw-native-nav,
            .openclaw-native-web-chrome
          )
          #openclaw-boot-composer {
          grid-column: 2;
          grid-row: 2;
          min-width: 0;
          min-height: 24px;
          max-height: 144px;
          padding: 0;
          border-radius: 0;
          font-family: var(
            --font-body,
            "Instrument Sans",
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            Roboto,
            sans-serif
          );
          line-height: 24px;
          scrollbar-gutter: auto;
        }
      }

      @media (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        html[data-openclaw-boot-chat]:not(
            .openclaw-native-macos,
            .openclaw-native-nav,
            .openclaw-native-web-chrome
          )
          #openclaw-boot-composer {
          max-height: 56px;
          overflow-y: auto;
        }
      }

      /* Use the same skeleton nodes before and after Solid takes over. New
         Session starts with its welcome and draft, never a chat transcript. */
      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton {
        padding-top: calc(clamp(44px, 5vh, 52px) + clamp(20px, 4vh, 40px));
        padding-inline: 36px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__header {
        flex-direction: column;
        gap: 12px;
        height: auto;
        margin: 0;
        padding: 0;
        border: 0;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__header
        .loading-skeleton__avatar {
        width: 96px;
        height: 96px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__title {
        width: 160px;
        height: 30px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__messages {
        flex: none;
        gap: 0;
        margin-top: 6px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__message--user {
        align-self: center;
        width: 100%;
        justify-items: center;
        gap: 44px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__message--user
        > :first-child {
        width: min(100%, 280px);
        height: 20px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__message--user
        > :last-child {
        width: 100%;
        height: 32px;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__message:not(.loading-skeleton__message--user) {
        display: none;
      }

      :is(
          html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
          .connect-splash[data-route="new"]
        )
        .loading-skeleton__composer {
        height: 144px;
        border-radius: 12px;
      }

      /* Settings owns a narrower sidebar; list routes retain the normal
         rail. No route below starts with a transcript or a chat composer. */
      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"]
        )
        .connect-splash__layout {
        grid-template-columns: 288px minmax(0, 1fr);
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"]
        )
        .connect-splash__sidebar {
        padding-inline-start: 20px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"]
        )
        .connect-splash__sidebar::before {
        display: none;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton {
        padding: 6px 20px 32px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__header {
        width: min(100%, 1120px);
        height: 40px;
        justify-content: center;
        margin: 0 auto;
        padding: 0;
        border: 0;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__header
        .loading-skeleton__avatar,
      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__message
        .loading-skeleton__avatar,
      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__composer {
        display: none;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__title {
        height: 26px;
        width: 180px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__messages {
        flex: none;
        gap: 24px;
        width: min(100%, 1120px);
        margin-top: 32px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__message {
        width: 100%;
        gap: 24px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"],
          html[data-openclaw-boot-route="sessions"] #openclaw-boot-shell,
          .connect-splash[data-route="sessions"],
          html[data-openclaw-boot-route="cron"] #openclaw-boot-shell,
          .connect-splash[data-route="cron"]
        )
        .loading-skeleton__message--user {
        align-self: stretch;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"]
        )
        .loading-skeleton {
        padding: 44px clamp(28px, 5vw, 72px) 32px;
      }

      :is(
          html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
          .connect-splash[data-route="settings"]
        )
        .loading-skeleton__header {
        justify-content: flex-start;
      }

      /* Chat Details automatically reserves 300px plus its 13px inset in a
         frame at least 1200px wide. Match that first painted destination. */
      @container (min-width: 1200px) {
        html[data-openclaw-boot-chat] #openclaw-boot-shell .loading-skeleton,
        .connect-splash[data-chat] .loading-skeleton,
        .content--workbench .lazy-view-state--route .loading-skeleton {
          padding-inline-end: 331px;
        }

        html[data-openclaw-boot-chat] #openclaw-boot-shell .loading-skeleton__header,
        .connect-splash[data-chat] .loading-skeleton__header,
        .content--workbench .lazy-view-state--route .loading-skeleton__header {
          margin-inline-end: -331px;
        }

        html[data-openclaw-boot-chat] #openclaw-boot-shell .connect-splash__status,
        .connect-splash[data-chat] .connect-splash__status,
        .content--workbench .lazy-view-state--route .connect-splash__status {
          inset-inline-end: 331px;
        }
      }

      @media (max-width: 900px),
        (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        .connect-splash__layout {
          grid-template-columns: minmax(0, 1fr);
        }

        :is(
            html[data-openclaw-boot-route="settings"] #openclaw-boot-shell,
            .connect-splash[data-route="settings"]
          )
          .connect-splash__layout {
          grid-template-columns: minmax(0, 1fr);
        }

        .connect-splash__sidebar {
          display: none;
        }

        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .connect-splash__status {
          inset-inline-start: 18px;
        }
      }

      @media (max-width: 768px) {
        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton {
          padding: 0 16px 10px;
        }

        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton__header {
          height: 58px;
          margin-inline: -16px;
        }

        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .loading-skeleton__composer {
          height: 52px;
          border-radius: 22px;
        }

        :is(.connect-splash--skeleton, .content--workbench .lazy-view-state--route)
          .connect-splash__status {
          bottom: 26px;
        }

        :is(
            html[data-openclaw-boot-chat] #openclaw-boot-shell,
            .connect-splash[data-chat],
            .content--workbench .lazy-view-state--route[data-chat]
          )
          .connect-splash__status {
          bottom: 112px;
        }
      }

      @media (max-width: 768px),
        (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton {
          justify-content: center;
          padding: 76px 18px 24px;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__header
          .loading-skeleton__avatar {
          width: 56px;
          height: 56px;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__title {
          height: 24px;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__message--user {
          gap: 24px;
        }
      }

      @media (max-width: 768px) and (max-height: 500px),
        (max-width: 932px) and (max-height: 500px) and (orientation: landscape) {
        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton {
          padding-top: 64px;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__header {
          flex-direction: row;
          justify-content: center;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__header
          .loading-skeleton__avatar {
          width: 36px;
          height: 36px;
        }

        :is(
            html[data-openclaw-boot-route="new"] #openclaw-boot-shell,
            .connect-splash[data-route="new"]
          )
          .loading-skeleton__message--user
          > :first-child {
          display: none;
        }
      }

      body.openclaw-mount-fallback-active {
        --mount-fallback-bg: var(--bg, #111318);
        --mount-fallback-card: var(--card, #161920);
        --mount-fallback-text: var(--text-strong, #f4f4f5);
        --mount-fallback-muted: var(--muted, #8b8b94);
        --mount-fallback-link: var(--link, #ff7070);
        --mount-fallback-ring: var(--ring, #ff5c5c);

        margin: 0;
        color: var(--mount-fallback-text);
        background: var(--mount-fallback-bg);
        font-family: var(
          --font-body,
          ui-sans-serif,
          system-ui,
          -apple-system,
          BlinkMacSystemFont,
          "Segoe UI",
          sans-serif
        );
        -webkit-font-smoothing: antialiased;
      }

      body.openclaw-mount-fallback-active openclaw-app {
        display: none;
      }

      .mount-fallback {
        box-sizing: border-box;
        /* The app stylesheet clips the root scrollers, so this pre-app error
           surface must own its scrolling on short windows. dvh keeps the
           scroll range inside the visible mobile viewport; vh is the fallback. */
        height: 100vh;
        height: 100dvh;
        overflow-y: auto;
        padding: max(24px, env(safe-area-inset-top)) max(24px, env(safe-area-inset-right))
          max(24px, env(safe-area-inset-bottom)) max(24px, env(safe-area-inset-left));
        place-items: center;
        place-items: safe center;
      }

      .mount-fallback:not([hidden]) {
        display: grid;
      }

      .mount-fallback__panel {
        box-sizing: border-box;
        width: min(100%, 560px);
        border: 1px solid color-mix(in srgb, var(--mount-fallback-text) 7%, transparent);
        border-radius: 20px;
        background: var(--mount-fallback-card);
        box-shadow: var(--shadow-lg, 0 12px 32px rgba(0, 0, 0, 0.2));
        padding: 32px;
      }

      .mount-fallback__panel .mount-fallback__eyebrow {
        margin: 0 0 16px;
        color: var(--mount-fallback-muted);
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .mount-fallback__panel h1 {
        margin: 0;
        color: inherit;
        font-size: clamp(1.375rem, 3vw, 1.625rem);
        font-weight: 650;
        letter-spacing: -0.02em;
        line-height: 1.25;
      }

      .mount-fallback__panel p {
        margin: 12px 0 0;
        color: var(--mount-fallback-muted);
        font-size: 0.9375rem;
        line-height: 1.55;
      }

      .mount-fallback__panel ul {
        margin: 18px 0 0;
        padding-left: 1.2rem;
        color: var(--mount-fallback-muted);
        font-size: 0.875rem;
        line-height: 1.55;
      }

      .mount-fallback__panel li + li {
        margin-top: 8px;
      }

      .mount-fallback__panel a {
        color: var(--mount-fallback-link);
        text-decoration-thickness: 0.08em;
        text-underline-offset: 0.18em;
      }

      .mount-fallback__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 24px;
      }

      .mount-fallback__button {
        appearance: none;
        min-height: 44px;
        border: 0;
        border-radius: 10px;
        padding: 10px 16px;
        color: inherit;
        background: color-mix(in srgb, var(--mount-fallback-text) 8%, var(--mount-fallback-card));
        font: inherit;
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 1.4;
        cursor: default;
        transition: background 120ms ease;
      }

      .mount-fallback__button:hover {
        background: color-mix(in srgb, var(--mount-fallback-text) 12%, var(--mount-fallback-card));
      }

      .mount-fallback__button:active {
        background: color-mix(in srgb, var(--mount-fallback-text) 16%, var(--mount-fallback-card));
      }

      .mount-fallback__button--primary {
        color: var(--primary-foreground, #ffffff);
        background: var(--primary, #d13c3c);
      }

      .mount-fallback__button--primary:hover,
      .mount-fallback__button--primary:active {
        background: var(--primary-hover, #c22e2e);
      }

      .mount-fallback__panel:focus {
        outline: none;
      }

      .mount-fallback__button:focus-visible,
      .mount-fallback__panel a:focus-visible {
        outline: 2px solid var(--mount-fallback-ring);
        outline-offset: 3px;
      }

      html[data-theme-mode="light"] body.openclaw-mount-fallback-active {
        --mount-fallback-bg: var(--bg, #f4f4f4);
        --mount-fallback-card: var(--card, #ffffff);
        --mount-fallback-text: var(--text-strong, #18181b);
        --mount-fallback-muted: var(--muted, #64646e);
        --mount-fallback-link: var(--link, #b91c1c);
        --mount-fallback-ring: var(--ring, #dc2626);
      }

      html[data-theme-mode="light"] .mount-fallback__panel {
        box-shadow: var(--shadow-lg, 0 12px 32px rgba(15, 23, 42, 0.08));
      }

      @media (max-width: 560px) {
        .mount-fallback__panel {
          padding: 24px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .mount-fallback__button {
          transition: none;
        }
      }
    </style>
  </head>
  <body>
    <openclaw-app>
      <!-- Solid replaces this public, data-free frame in its first commit. -->
      <main
        id="openclaw-boot-shell"
        class="connect-splash connect-splash--skeleton"
        role="status"
        aria-label="Loading"
      >
        <div class="connect-splash__layout">
          <aside class="connect-splash__sidebar" aria-hidden="true">
            <div class="skeleton loading-skeleton__avatar"></div>
            <div class="skeleton connect-splash__new-session"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
          </aside>
          <div class="connect-splash__main">
            <div class="loading-skeleton">
              <div class="loading-skeleton__header" aria-hidden="true">
                <div class="skeleton loading-skeleton__avatar"></div>
                <div class="skeleton skeleton-line loading-skeleton__title"></div>
              </div>
              <div class="loading-skeleton__messages" aria-hidden="true">
                <div class="loading-skeleton__message loading-skeleton__message--user">
                  <div class="skeleton skeleton-line"></div>
                  <div class="skeleton skeleton-line skeleton-line--medium"></div>
                </div>
                <div class="loading-skeleton__message">
                  <div class="skeleton loading-skeleton__avatar"></div>
                  <div class="skeleton skeleton-line"></div>
                  <div class="skeleton skeleton-line skeleton-line--long"></div>
                  <div class="skeleton skeleton-line skeleton-line--medium"></div>
                </div>
              </div>
              <div class="skeleton loading-skeleton__composer">
                <textarea
                  id="openclaw-boot-composer"
                  rows="1"
                  dir="auto"
                  enterkeyhint="enter"
                  placeholder="Message…"
                ></textarea>
              </div>
            </div>
            <span class="connect-splash__status" aria-hidden="true">Loading…</span>
          </div>
        </div>
      </main>
    </openclaw-app>
    <script data-cfasync="false">
      // A chat link accepts typing at first paint; Enter only records intent.
      // app/boot-composer.ts carries this element to the chat pane. Enter, IME
      // and touch rules mirror lib/ime.ts, lib/browser-platform.ts and the chat
      // composer's keydown handler.
      (function () {
        var root = document.documentElement;
        var input = document.getElementById("openclaw-boot-composer");
        if (!input || !root.hasAttribute("data-openclaw-boot-chat")) return;
        var nav = navigator;
        // Touch Return keeps native editing, matching the chat composer.
        var touch =
          /iPad|iPhone|iPod|Android/.test(nav.userAgent) ||
          (nav.platform === "MacIntel" && nav.maxTouchPoints > 1);
        var modifier = root.hasAttribute("data-openclaw-boot-send-shortcut");
        var composedAt = -1;
        input.addEventListener("compositionend", function (event) {
          composedAt = event.timeStamp;
        });
        input.addEventListener("keydown", function (event) {
          if (
            event.key !== "Enter" ||
            event.shiftKey ||
            touch ||
            event.isComposing ||
            event.keyCode === 229 ||
            (composedAt >= 0 && Math.abs(event.timeStamp - composedAt) < 100) ||
            (modifier && !event.metaKey && !event.ctrlKey)
          ) {
            return;
          }
          event.preventDefault();
          input.toggleAttribute("data-submit-queued", input.value.trim() !== "");
        });
        input.addEventListener("input", function () {
          input.removeAttribute("data-submit-queued");
        });
        input.addEventListener("focus", function () {
          input.setAttribute("data-focused", "");
        });
        input.addEventListener("blur", function () {
          // Loading frames move this node within a task; a lasting blur is the operator's.
          setTimeout(function () {
            if (input.isConnected && document.activeElement !== input) {
              input.removeAttribute("data-focused");
            }
          }, 0);
        });
      })();
    </script>
    <section
      id="openclaw-mount-fallback"
      class="mount-fallback"
      data-openclaw-mount-timeout-ms="12000"
      role="alert"
      aria-labelledby="openclaw-mount-fallback-title"
      hidden
    >
      <div class="mount-fallback__panel" tabindex="-1">
        <p class="mount-fallback__eyebrow">OpenClaw Control UI</p>
        <h1 id="openclaw-mount-fallback-title">Control UI did not start</h1>
        <p id="openclaw-mount-fallback-summary">
          The browser loaded the static page, but the app bundle did not start. The gateway may be
          restarting, or this page may reference assets from a different OpenClaw version.
        </p>
        <ul>
          <li>If startup fails, OpenClaw will retry the current app bundle automatically.</li>
          <li>If this persists, reload or try a clean browser profile.</li>
          <li>
            See
            <a
              href="https://docs.openclaw.ai/web/control-ui#blank-control-ui-page"
              target="_blank"
              rel="noopener noreferrer"
              >Control UI troubleshooting</a
            >.
          </li>
        </ul>
        <div class="mount-fallback__actions">
          <button
            type="button"
            id="openclaw-mount-retry"
            class="mount-fallback__button mount-fallback__button--primary"
          >
            Try again
          </button>
          <button type="button" id="openclaw-mount-wait" class="mount-fallback__button">
            Keep waiting
          </button>
        </div>
      </div>
    </section>
    <script data-cfasync="false">
      (function () {
        var app = document.querySelector("openclaw-app");
        var fallback = document.getElementById("openclaw-mount-fallback");
        if (!app || !fallback) return;

        var panel = fallback.querySelector(".mount-fallback__panel");
        var title = document.getElementById("openclaw-mount-fallback-title");
        var summary = document.getElementById("openclaw-mount-fallback-summary");
        var failureSummary = summary.textContent;
        var retry = document.getElementById("openclaw-mount-retry");
        var wait = document.getElementById("openclaw-mount-wait");
        var rawDelay = Number(fallback.getAttribute("data-openclaw-mount-timeout-ms"));
        var delay = Number.isFinite(rawDelay) && rawDelay > 0 ? rawDelay : 12000;
        var maxRecoveryNavigations = 3;
        var timer;
        var recoveryTimer;
        var recoveryAttempt = 0;
        var recoveryNavigation = 0;
        var bootSettled = false;
        var documentLoaded = document.readyState === "complete";
        var recoveryController;

        // The recovery page cannot import the app's drag helper when its bundle failed.
        fallback.addEventListener("mousedown", function (event) {
          if (event.button !== 0 || event.defaultPrevented || event.target !== fallback) return;
          var drag = window.webkit?.messageHandlers?.openclawWindowDrag;
          if (!drag) return;
          try {
            drag.postMessage({ type: "window-drag" });
            event.preventDefault();
          } catch (e) {}
        });

        try {
          var initialUrl = new URL(window.location.href);
          var recoveryMarker = initialUrl.searchParams.get("openclaw_mount_recovery");
          // Runtime reloads pass a timestamp cache buster; count it as the first recovery navigation.
          if (recoveryMarker !== null) {
            var count = Number(recoveryMarker);
            recoveryNavigation =
              Number.isInteger(count) && count >= 1 && count <= maxRecoveryNavigations ? count : 1;
          }
          if (recoveryNavigation || initialUrl.searchParams.has("openclaw_http_auth")) {
            initialUrl.searchParams.delete("openclaw_mount_recovery");
            initialUrl.searchParams.delete("openclaw_http_auth");
            window.history.replaceState(null, "", initialUrl.href);
          }
        } catch (e) {}

        function hideFallback() {
          fallback.hidden = true;
          document.body.classList.remove("openclaw-mount-fallback-active");
        }

        function setSummary(text) {
          if (summary) summary.textContent = text;
        }

        function cancelRecovery() {
          window.clearTimeout(recoveryTimer);
          if (recoveryController) recoveryController.abort();
          recoveryController = undefined;
        }

        function scheduleRecovery() {
          window.clearTimeout(recoveryTimer);
          if (bootSettled) return;
          var retryDelay = Math.min(15000, 1000 * Math.pow(2, Math.min(recoveryAttempt - 1, 4)));
          recoveryTimer = window.setTimeout(retryCurrentDocument, retryDelay);
        }

        function finishRecoveryAttempt() {
          recoveryController = undefined;
          if (bootSettled) return;
          setSummary(
            "The gateway is not reachable yet. OpenClaw will keep retrying while it restarts.",
          );
          scheduleRecovery();
        }

        function retryCurrentDocument() {
          if (bootSettled || recoveryController || typeof window.fetch !== "function") return;
          var documentUrl = new URL(window.location.href);
          if (recoveryNavigation >= maxRecoveryNavigations) {
            setSummary(
              "A fresh page still could not start the Control UI. Try again, then check the troubleshooting guide if the problem persists.",
            );
            return;
          }
          recoveryAttempt += 1;
          documentUrl.searchParams.set("openclaw_mount_recovery", String(recoveryNavigation + 1));
          var controller = new AbortController();
          recoveryController = controller;
          var requestTimer = window.setTimeout(function () {
            controller.abort();
          }, delay);
          window
            .fetch(documentUrl.href, {
              cache: "no-store",
              credentials: "same-origin",
              signal: controller.signal,
            })
            .then(function (response) {
              if (!response.ok) throw new Error("gateway unavailable");
              if (!bootSettled && recoveryController === controller)
                window.location.replace(documentUrl.href);
            })
            .catch(function () {
              if (recoveryController !== controller) return;
              // Network failure says nothing about worker health. Keep offline recovery.
              finishRecoveryAttempt();
            })
            .finally(function () {
              window.clearTimeout(requestTimer);
            });
        }

        function showFallback() {
          if (bootSettled) return;
          title.textContent = documentLoaded
            ? "Control UI did not start"
            : "Control UI is still loading";
          fallback.setAttribute("role", documentLoaded ? "alert" : "status");
          setSummary(
            documentLoaded
              ? failureSummary
              : "The browser is still loading the app. OpenClaw will keep waiting without interrupting the download.",
          );
          if (documentLoaded) retryCurrentDocument();
          fallback.hidden = false;
          document.body.classList.add("openclaw-mount-fallback-active");
          if (documentLoaded && panel && typeof panel.focus === "function") {
            try {
              panel.focus({ preventScroll: true });
            } catch (e) {
              panel.focus();
            }
          }
        }

        function armFallbackTimer() {
          window.clearTimeout(timer);
          timer = window.setTimeout(showFallback, delay);
        }

        armFallbackTimer();

        // The nonblocking entry sheet can outlive DOMContentLoaded. A slow
        // download is not a failed bootstrap: recovery would cancel it.
        document.addEventListener(
          "DOMContentLoaded",
          function () {
            var styles = document.getElementById("openclaw-boot-styles");
            function finishDocumentLoad() {
              if (styles) {
                styles.removeEventListener("load", finishDocumentLoad);
                styles.removeEventListener("error", finishDocumentLoad);
              }
              documentLoaded = true;
              if (!bootSettled) armFallbackTimer();
            }
            if (styles && styles.media === "print") {
              styles.addEventListener("load", finishDocumentLoad, { once: true });
              styles.addEventListener("error", finishDocumentLoad, { once: true });
            } else {
              finishDocumentLoad();
            }
          },
          { once: true },
        );

        function retireMountRecovery() {
          bootSettled = true;
          window.clearTimeout(timer);
          cancelRecovery();
          hideFallback();
        }

        window.addEventListener("openclaw-control-ui-rendered", retireMountRecovery, {
          once: true,
        });
        // Admission rejection is terminal even while its fallback assets are still loading.
        window.addEventListener("openclaw-control-ui-unsupported-browser", retireMountRecovery, {
          once: true,
        });

        window.addEventListener(
          "openclaw-control-ui-unsupported-browser-failed",
          function () {
            title.textContent = "Browser guidance could not load";
            setSummary("Check your connection, then try again to load the browser requirements.");
            fallback.querySelector("ul").hidden = true;
            wait.hidden = true;
            fallback.hidden = false;
            document.body.replaceChildren(fallback);
            document.body.classList.add("openclaw-mount-fallback-active");
            retry.focus();
          },
          { once: true },
        );

        if (retry) {
          retry.addEventListener("click", function () {
            cancelRecovery();
            window.location.reload();
          });
        }
        if (wait) {
          wait.addEventListener("click", function () {
            hideFallback();
            cancelRecovery();
            recoveryAttempt = 0;
            armFallbackTimer();
          });
        }
      })();
    </script>
    <script data-cfasync="false" type="module" src="/src/main.ts"></script>
  </body>
</html>
